function formatAge(timestamp, now) {
  const moment = Date.parse(timestamp);
  if (!Number.isFinite(moment)) return "Updated at an unknown time";

  const elapsedSeconds = Math.max(0, Math.floor((now.getTime() - moment) / 1000));
  if (elapsedSeconds < 60) return `Updated ${elapsedSeconds} sec ago`;
  if (elapsedSeconds < 3600) {
    return `Updated ${Math.floor(elapsedSeconds / 60)} min ago`;
  }
  return `Updated ${Math.floor(elapsedSeconds / 3600)} hr ago`;
}

/**
 * The header may only claim LIVE when a fresh snapshot says GoldBot is
 * running. Anything else — unreachable API, stale snapshot, stopped bot — has
 * to say so.
 */
export function buildHeaderState({ data, error, isLoading, now = new Date() }) {
  if (!data) {
    if (isLoading) {
      return {
        label: "CONNECTING",
        tone: "connecting",
        detail: "Contacting GoldBot API",
      };
    }
    return {
      label: "OFFLINE",
      tone: "offline",
      detail: "GoldBot API unavailable",
    };
  }

  if (error) {
    return {
      label: "OFFLINE",
      tone: "offline",
      detail: "GoldBot API unavailable",
    };
  }

  if (data.stale) {
    return {
      label: "STALE",
      tone: "connecting",
      detail: formatAge(data.last_update, now),
    };
  }

  const status = String(data.goldbot_status || "").toUpperCase();
  if (status !== "RUNNING") {
    return {
      label: status || "UNKNOWN",
      tone: "offline",
      detail: formatAge(data.last_update, now),
    };
  }

  return {
    label: "LIVE",
    tone: "online",
    detail: formatAge(data.last_update, now),
  };
}
